import SkeletonBlock from '../SkeletonBlock';

export default function TableSkeleton({ rows = 5, cols = 4 }) {
  return (
    <div className="card-flush overflow-x-auto">
      <div className="border-b border-neutral-200 dark:border-neutral-700 px-6 py-3 bg-neutral-50 dark:bg-neutral-900/50 flex gap-6">
        {Array.from({ length: cols }).map((_, i) => (
          <SkeletonBlock key={i} className="h-3 w-20" rounded="rounded" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 px-6 py-4 border-b border-neutral-100 dark:border-neutral-700/50 last:border-0">
          <SkeletonBlock className="w-8 h-8 shrink-0" rounded="rounded-full" />
          <SkeletonBlock className={`h-4 ${i % 2 === 0 ? 'w-36' : 'w-28'}`} rounded="rounded" />
          {cols > 2 && <SkeletonBlock className="h-4 w-40 hidden sm:block" rounded="rounded" />}
          {cols > 3 && <SkeletonBlock className="h-4 w-24 hidden md:block" rounded="rounded" />}
          <SkeletonBlock className="h-5 w-14 ml-auto" rounded="rounded-full" />
        </div>
      ))}
    </div>
  );
}
